import React from "react";
import SvgIconDPC from "../dpc-svg-icon";
import NavigaIcon from "../../assets/naviga.svg";
import ShareIcon from "../../assets/condividi.svg";
export default class DpcNavbar extends React.Component {

    chunk = (arr, size) => arr.reduce((acc, e, i) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []);

    /*isSelected(item) {
        if(typeof window !== "undefined" && item.link){
            const pathname = item.link.split("/index.html")[0];
            return window.location.pathname.includes(pathname);
        }
    }*/

    getChildren(children) {
        let newArray = [...children];
        return this.chunk(newArray, Math.min(2, newArray.length))
    }

    render() {
        return (
            <div className="it-header-subnavbar-wrapper">
                <div className="container">
                    <div className="px-custom">
                        <div className="row">
                            <div className="col-6 d-xl-none">
                                <div className="share-buttons share-buttons-left reveal-content">
                                    <div className="share-buttons-container">
                                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${typeof window !== `undefined` ? window.location.href : null}`}
                                           title="Condividi su Facebook" target="_blank" rel="noreferrer">
                                            <SvgIconDPC name='facebook-square'/>
                                            <span className="sr-only">Condividi su Facebook</span>
                                        </a>
                                        <a href={`https://www.twitter.com/share?text=Il%20Sito%20web%20del%20Dipartimento%20della%20Protezione%20Civile&amp;url=${typeof window !== `undefined` ? window.location.href : null}`}
                                           title="Condividi su Twitter" target="_blank" rel="noreferrer">
                                            <SvgIconDPC name='twitter-square'/>
                                            <span className="sr-only">Condividi su Twitter</span>
                                        </a>
                                        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${typeof window !== `undefined` ? window.location.href : null}`}
                                           title="Condividi su LinkedIn" target="_blank" rel="noreferrer">
                                            <SvgIconDPC name='linkedin-square'/>
                                            <span className="sr-only">Condividi su LinkedIn</span>
                                        </a>
                                    </div>
                                    <span>Condividi</span>
                                    <a href="#" className="share-buttons-trigger reveal-trigger"
                                       title="Condividi sui social network" tabIndex="-1">
                                        <ShareIcon/>
                                        <span className="sr-only">Condividi sui social network</span>
                                    </a>
                                </div>
                            </div>
                            {(Array.isArray(this.props.menuItems) && this.props.menuItems.length > 0) ?

                            <div className="col-6 col-xl-12">
                                <nav className="navbar navbar-expand-xl has-megamenu" aria-label="Menu secondario">
                                    <span id="navSubDescr">Naviga</span>
                                    <button className="custom-navbar-toggler" type="button" aria-controls="navSub"
                                            aria-expanded="false" aria-describedby="navSubDescr"
                                            data-target="#navSub"
                                            title="Navigazione menu secondario">
                                        <NavigaIcon/>
                                    </button>
                                    <div className="navbar-collapsable" id="navSub">
                                        <div className="overlay"/>
                                        <div className="menu-wrapper">
                                            <div className="close-div">
                                                <button className="btn close-menu" type="button"
                                                        title="Chiudi menu">
                                                    <SvgIconDPC name={'close'}/>
                                                </button>
                                            </div>
                                            <ul className="navbar-nav">
                                                {
                                                    Array.isArray(this.props.menuItems) && this.props.menuItems.filter(item => item.title.toLowerCase() !== 'homepage').sort((a,b) => {
                                                        return a.weight > b.weight ? 1 : -1;
                                                    }).map((item, i) => {
                                                       // if (item.children.length === 0)
                                                            return (
                                                                <li className="nav-item">
                                                                    <a className={`nav-link ${item.active ? "active" : ""}`}
                                                                       href={item.link}><span>{item.title}</span>
                                                                    { item.active && 
                                                                       <span className="sr-only">current</span>
                                                                    }
                                                                       </a>
                                                                </li>
                                                            );
                                                       /* else
                                                            return (
                                                                <li className="nav-item dropdown megamenu">
                                                                    <a className="nav-link dropdown-toggle"
                                                                       href={item.link ? item.link: '#'}
                                                                       data-toggle="dropdown" aria-expanded="false">
                                                                        <span>{item.title}</span>
                                                                        <SvgIconDPC name={'expand'}/>
                                                                    </a>
                                                                    <div className="dropdown-menu">
                                                                        <div className="link-list-wrapper">
                                                                            <ul className="link-list">
                                                                                <li>
                                                                                    <h3>Heading TODO</h3>
                                                                                </li>
                                                                                {
                                                                                    item.children.length > 0 && (
                                                                                        this.getChildren(item.children).map(child => (
                                                                                            child.map(item => (
                                                                                            <li>
                                                                                                <a className="list-item"
                                                                                                   href={item.link}><span>{item.title}</span></a>
                                                                                            </li>
                                                                                            ))
                                                                                           
                                                                                        ))
                                                                                    )}
                                                                                <li><span className="divider"/>TODO</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )*/
                                                    })
                                                }

                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                            :null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
